import { deleteUser } from './../../../store/modules/profile'
import DeleteMyAccount from './DeleteMyAccount'
import { compose } from 'ramda'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  deleting: state.profile.isDeleting,
  error: state.profile.deleteError,
  locale: state.router.locale,
})

const mapDispatchToProps = dispatch => ({
  confirm: compose(dispatch, deleteUser),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteMyAccount)
